<!-- =========================
     FULLSCREEN BACKGROUND
========================= -->
<div class="min-vh-100 position-relative overflow-hidden">

  <!-- Dark Overlay (Bootstrap-friendly) -->
  <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50"></div>

  <div v-if="error_message || success_message" class="toast-container position-fixed bottom-0 end-0 p-3" aria-live="polite" aria-atomic="true">
    <div v-if="error_message" class="toast show align-items-center text-white border-0 shadow-lg auth-toast auth-toast-error" role="alert">
      <div class="d-flex align-items-center gap-3 p-3">
      <span class="auth-toast-icon rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0" aria-hidden="true">
        <i class="bi bi-exclamation-circle"></i>
      </span>
      <div class="toast-body p-0 fw-semibold lh-sm">{{ error_message }}</div>
      <button type="button" class="btn-close btn-close-white ms-auto flex-shrink-0" aria-label="Dismiss error message" @click="clear_error_message"></button>
      </div>
    </div>

    <div v-if="success_message" class="toast show align-items-center text-white border-0 shadow-lg auth-toast auth-toast-success" role="status">
      <div class="d-flex align-items-center gap-3 p-3">
      <span class="auth-toast-icon rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0" aria-hidden="true">
        <i class="bi bi-check2-circle"></i>
      </span>
      <div class="toast-body p-0 fw-semibold lh-sm">{{ success_message }}</div>
      <button type="button" class="btn-close btn-close-white ms-auto flex-shrink-0" aria-label="Dismiss success message" @click="clear_success_message"></button>
      </div>
    </div>
  </div>

  <!-- =========================
       CONTENT LAYER
  =========================== -->
  <div class="container position-relative z-1 min-vh-100 d-flex align-items-center justify-content-center">
    <div class="row justify-content-center align-items-center w-100">

      <!-- =========================
           LOGIN (Glass Card Style)
      =========================== -->
      <div
        class="glass-card p-4 p-md-5 rounded-4 shadow-sm
               col-12 col-sm-8 col-md-6 col-lg-5 col-xl-5 mx-auto"
      >

        <!-- Logo -->
        <div class="text-center mb-3">
          <router-link
            to="/"
            class="auth-logo mb-2 text-decoration-none d-inline-block"
            aria-label="Bolide Home"
          ></router-link>
        </div>

        <!-- Heading -->
        <h3 class="fw-bold mb-1 text-center text-white">
          Welcome Back
        </h3>

        <p class="text-center text-white-50 mb-4 text-sm">
          Login to continue exploring insights.
        </p>

        <!-- =========================
             LOADING STATE
        =========================== -->
        <div v-if="is_loading" class="text-center mb-3">
          <div class="spinner-border spinner-border-sm me-2 text-primary"></div>
          <span class="text-white-50">Authenticating...</span>
        </div>

        <!-- =========================
             LOGIN FORM
        =========================== -->
        <form @submit.prevent="handle_login" v-if="!is_loading">

          <!-- Email -->
          <div class="mb-3">
            <label class="form-label text-xs text-white-50">Email</label>
            <input
              v-model="credentials.email"
              type="email"
              class="form-control form-control-sm rounded-3
                    bg-transparent text-white border-secondary placeholder-white"
              placeholder="Enter email"
              required
            />
          </div>

          <!-- Password -->
          <div class="mb-3">
            <label class="form-label text-xs text-white-50 mb-1">Password</label>
            <div class="position-relative">
              <input
                v-model="credentials.password"
                :type="password_input_type"
                class="form-control form-control-sm rounded-3 pe-5
                      bg-transparent text-white border-secondary placeholder-white"
                placeholder="Enter password"
                required
              />
              <button
                type="button"
                class="btn position-absolute top-50 end-0 translate-middle-y px-2"
                @click="toggle_change_password_type"
                :aria-label="password_input_type === 'password' ? 'Show password' : 'Hide password'"
              >
                <i :class="password_input_type === 'password' ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
              </button>
            </div>
          </div>

          <!-- Login Button -->
          <button
            class="btn btn-primary w-100 rounded-3 fw-light text-xs mb-3"
            :disabled="is_loading"
          >
            Login
          </button>

          <!-- Forgot Password -->
          <p class="text-center text-white-50 text-xs mb-0">
            Forgot your password?
            <router-link
              to="/reset_password"
              class="text-decoration-none text-primary"
            >
              Reset
            </router-link>
          </p>

        </form>
      </div>

    </div>
  </div>
</div>
